import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { OnboardingPages } from '../../../../common/src/pages.ts';
import { LocalStorageKey, localStorageRemove, localStorageSet } from '../../data/client_local_storage.ts';
import { synchronizeOrgsWithServer, useCurrentOrg } from '../../data/use_current_org.tsx';
import { memberForEmail } from '../../data/use_household.tsx';
import { useLocalStorage } from '../../data/use_local_storage.tsx';
import { alert } from '../../util/confirm.tsx';
import { Button } from './button.tsx';
import { BoldMessage, goToNextOnboardingStep, isAdminInvite, isSubscribing, Message } from './common.tsx';
import { Frame } from './frame.tsx';

export const HouseholdJoin = () => {
  const [householdEmail] = useLocalStorage(LocalStorageKey.OnboardingHouseholdEmail);
  const [household] = useLocalStorage(LocalStorageKey.OnboardingMatchingHousehold);
  const [onboardingOrg] = useLocalStorage(LocalStorageKey.OnboardingOrg);
  const { setHouseholdOrg } = useCurrentOrg();
  const navigate = useNavigate();

  const onJoinHousehold = useCallback(async () => {
    if (!household) {
      await alert({ confirmation: <span>An error occurred joining household</span> });
      await goToNextOnboardingStep(navigate, { from: OnboardingPages.HouseholdJoin, action: 'householdMissing' });
      return;
    }
    localStorageSet(LocalStorageKey.Household, household);
    const member = memberForEmail(household, householdEmail);
    if (member) {
      localStorageSet(LocalStorageKey.ActiveUserToken, member.token);
    }
    await synchronizeOrgsWithServer({ force: true });
    // an admin invite sets the household's org itself, from the invite
    if (!isAdminInvite()) {
      if (onboardingOrg) {
        await setHouseholdOrg(onboardingOrg);
      }
      await synchronizeOrgsWithServer({ force: true });
    }
    await goToNextOnboardingStep(navigate, { from: OnboardingPages.HouseholdJoin, action: 'join', household });
  }, [household, householdEmail, onboardingOrg, setHouseholdOrg, navigate]);
  const onEditEmail = useCallback(async () => {
    localStorageRemove(LocalStorageKey.OnboardingMatchingHousehold);
    await goToNextOnboardingStep(navigate, { from: OnboardingPages.HouseholdJoin, action: 'editEmail' });
  }, [navigate]);
  return (
    <Frame
      onboardingPage={OnboardingPages.HouseholdJoin}
      mainContent={
        <Message $widthInChars={26}>
          A household already exists with email <BoldMessage>{householdEmail}</BoldMessage>.<br />
          <br />
          {isSubscribing() ? 'Subscribe this household' : 'Would you like to join it'}?
        </Message>
      }
      footerContent={
        <>
          <Button onClick={onJoinHousehold}>YES</Button>
          <Button onClick={onEditEmail}>NO</Button>
        </>
      }
      onEnterKeypress={onJoinHousehold}
    />
  );
};
